"use strict";

exports.__esModule = true;
exports.default = exports.H4 = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Text = _interopRequireDefault(require("../text/Text"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledH4 = ({
  children,
  tag,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
  h4: true,
  tag: "h4",
  ...otherProps,
  children: children
});

const H4 = (0, _styledComponents.default)(StyledH4)`
    line-height: ${({
  theme
}) => theme.lineHeights.title};
    
    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.position}
`;
exports.H4 = H4;
H4.displayName = 'H4';
var _default = H4;
exports.default = _default;